import { useEffect, useRef } from "react";
import { CrownFilled } from "@ant-design/icons";
import styles from "./styles.module.css";

const SectionTabs = ({
  items = [],
  activeKey,
  onChange,
  onLocked,
  className = "",
}) => {
  const railRef = useRef(null);

  useEffect(() => {
    const active = railRef.current?.querySelector(`[data-key="${activeKey}"]`);
    active?.scrollIntoView({ block: "nearest", inline: "center" });
  }, [activeKey]);

  return (
    <div className={`${styles.rail} ${className}`} ref={railRef} role="tablist">
      {items.map((item) => (
        <button
          key={item.key}
          type="button"
          role="tab"
          data-key={item.key}
          aria-selected={activeKey === item.key}
          className={`${styles.tab} ${
            activeKey === item.key ? styles.tabActive : ""
          } ${item.locked ? styles.tabLocked : ""}`}
          onClick={() =>
            item.locked ? onLocked?.(item) : onChange(item.key)
          }
        >
          {item.icon && <span className={styles.icon}>{item.icon}</span>}
          {item.label}
          {item.locked && <CrownFilled className={styles.crown} />}
        </button>
      ))}
    </div>
  );
};

export default SectionTabs;
